import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const EPS: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Eps,
    name: 'eps',
    displayName: 'EPS'
};
